/* Saving one person's access on one account, through whichever Team path owns
   it: the Personal fleet (/me/team) or an Agency fleet. Both end in the same
   backend grant rules (member_access.py). */

import { api } from '../../../api/client';
import { isEmpty, toPayload, type Access } from './permissionModel';

/** `fleet` null = Personal fleet. `had` = the person already holds access here.
    `roleId` = the Role picked for these grants (links the person to it); without
    it the server keeps an existing link only while the grants still equal it. */
export async function persistAccess(fleet: string | null, uid: string, accountId: string, next: Access, had: boolean, roleId: string | null = null) {
  const { permissions, crm } = toPayload(next);
  if (fleet === null) {
    if (isEmpty(next)) { if (had) await api.revokeMemberAccountAccess(uid, accountId); }
    else if (had) await api.updateMemberAccountPermissions(uid, accountId, permissions, crm, roleId);
    else await api.assignMemberToAccount(uid, accountId, permissions, crm, roleId);
  } else if (isEmpty(next)) {
    if (had) await api.revokeAgencyMemberAccess(fleet, uid, accountId);
  } else {
    await api.setAgencyMemberAccess(fleet, uid, accountId, permissions, crm, roleId);
  }
}

/** Run `fn` over `items`, a few at a time; returns the errors (one per failed item). */
export async function runPool<T>(items: T[], fn: (item: T) => Promise<void>, onDone: () => void, width = 4): Promise<unknown[]> {
  const errors: unknown[] = [];
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const item = items[next++]!;
      try { await fn(item); } catch (e) { errors.push(e); }
      onDone();
    }
  };
  await Promise.all(Array.from({ length: Math.min(width, items.length) }, worker));
  return errors;
}
